// layout
export const SKEW = "-7deg";

export const MATRIX_NUMS = [0.9852, -0.121, 0, 1, 0, -20];
export const MATRIX = `matrix(${MATRIX_NUMS.join(", ")})`;
